function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Washing_machine"
}, /*#__PURE__*/React.createElement("title", null, "VF_washing_machine_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M21.3.1v283.4h240.9V0L21.3.1zm212.6 255H49.6V28.4h184.3v226.7z"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-.099 .359)",
  cx: "205.5",
  cy: "56.7",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "170.1",
  cy: "56.7",
  r: "14.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 241.2c43.1 0 78-24.3 78-78.1S184.8 85 141.7 85s-77.9 24.3-77.9 78.1 34.9 78.1 77.9 78.1zm36.1-39.9c-10.5 9.5-25.4 11.5-36.1 11.5s-25.6-2-36.1-11.5c-7.7-6.9-12.1-17.3-13.2-30.9 5.8 3.4 12.9 6.8 25.1 6.8 13.8 0 20.9-4.3 27.3-8.1 5.7-3.4 10.1-6.1 20-6.1s14.3 2.7 20 6.1c1.9 1.1 3.9 2.3 6 3.4-1.4 12.6-5.8 22.3-13 28.8zm-72.2-76.4c10.5-9.5 25.4-11.5 36.1-11.5s25.6 2 36.1 11.5c7.8 7.1 12.2 17.7 13.3 31.5-6.1-3.6-13.2-7.5-26.3-7.5-13.8 0-20.9 4.3-27.3 8.1-5.7 3.4-10.1 6.1-20 6.1s-14.3-2.7-20-6.1c-1.6-.9-3.2-1.9-5-2.9 1.4-12.7 5.8-22.5 13.1-29.2z"
}))));